import React, {useRef} from 'react';
import {useFrame} from '@react-three/fiber';
import {Mesh, Vector3} from 'three';

const LOADER_HEIGHT = 10;

interface IARModelLoaderProps {
  position: Vector3;
}

const ARModelLoader = ({position}: IARModelLoaderProps) => {
  const ref = useRef<Mesh>(null);
  const initialDeltaRef = useRef(0);

  useFrame((_s, delta) => {
    initialDeltaRef.current += delta;
    ref.current?.position.setY(LOADER_HEIGHT + 0.3 * Math.sin(4 * initialDeltaRef.current));
    ref.current?.rotateY(0.08);
  });

  return (
    <group position={position} scale={0.035}>
      <mesh key="shadow" receiveShadow rotation={[-Math.PI / 2, 0, 0]} scale={3.5}>
        <shadowMaterial opacity={0.1} />
        <planeGeometry />
      </mesh>
      <mesh ref={ref} position={[0, LOADER_HEIGHT, 0]} scale={2} castShadow>
        <meshStandardMaterial color="#34bb78" />
        <torusGeometry />
      </mesh>
    </group>
  );
};

export default React.memo(ARModelLoader);
